
export class Data {
    
    id : number;
    create_by: string;
    date_create: string;
    date_modif: string;
    discriminator: string;


    constructor() {

        this.id = 0; 
        
    }

}
    
